module.exports = __webpack_public_path__ + "static/img/footer-logo-2.45f0ffe7.png";